<template>
	<section class="tp-close-repars-by-technician">
		<div v-if="data.repaired">
			<div v-for="(repair, tec) in data.repaired" :key="tec">
				<span class="tech_name"
					><b>{{ tec }}</b></span
				>
				<ClosedRepairsByTechnicianTableReact
					v-if="repair.repairs"
					:repairs="repair.repairs"
				/>
			</div>
		</div>
	</section>
</template>
<script>
import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { ClosedRepairsByTechnicianTable } from "@/components/repair/ClosedRepairsByTechnicianTable";

const ClosedRepairsByTechnicianTableReact = ReactInVue(
	ClosedRepairsByTechnicianTable,
);

export default {
	components: {
		ClosedRepairsByTechnicianTableReact,
	},
	data() {
		return {
			data: {
				repaired: [],
				notRepaired: [],
				tec: null,
			},
		};
	},
	async created() {
		this.data = await this.$stellar.action("closedRepairsByTechnician");
	},
	methods: {},
};
</script>

<style lang="scss"></style>
